import type { ReactNode } from 'react';

import { Footer } from './footer';
import { Logo } from './logo';

interface PublicLayoutProps {
  title: string;
  copy: string;
  /** Extra hero content under the copy (reassurance list, benefits). */
  hero?: ReactNode;
  children: ReactNode;
}

/** Public-page frame: brand hero beside a card. */
export function PublicLayout({ title, copy, hero, children }: PublicLayoutProps) {
  return (
    <div className="public">
      <div className="public__body">
        <section className="hero stack">
          <Logo />
          <h1>{title}</h1>
          <hr className="divider" />
          <p className="lead">{copy}</p>
          {hero}
        </section>
        <section className="card stack">{children}</section>
      </div>
      <Footer />
    </div>
  );
}
